/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ReportIdNameReferenceFirstname } from './reportIdNameReferenceFirstname';
import type { ReportIdNameReferenceLastname } from './reportIdNameReferenceLastname';
import type { ReportIdNameReferenceExternalStudentId } from './reportIdNameReferenceExternalStudentId';

/**
 * Reference to a person in a report just by id and title.

None-valued fields (e.g. an unset external_student_id) are only omitted
from the wire response because the owning routes set
response_model_exclude_none=True — Pydantic v2 does not honor
ConfigDict(exclude_none=True) as a model_dump()/serialization default, so
that option is intentionally not declared here to avoid implying it does.
 */
export interface ReportIdNameReference {
  id: string;
  firstname?: ReportIdNameReferenceFirstname;
  lastname?: ReportIdNameReferenceLastname;
  externalStudentId?: ReportIdNameReferenceExternalStudentId;
}
